<template>
  <div class="register-page">
    <!-- 顶部栏 -->
    <div class="register-header">
      <div class="header-title">注册</div>
      <div class="header-back" @click="goBack">
        <img class="back-icon" src="@/assets/image/frame.png" />
        <span class="back-text">返回</span>
      </div>
    </div>

    <!-- 注册卡片 -->
    <div class="register-card">
      <!-- 用户类型切换 -->
      <div class="type-tabs">
        <div class="type-tab" :class="{ active: userType === 'buyer' }" @click="switchUserType('buyer')">采购方</div>
        <div class="type-tab" :class="{ active: userType === 'supplier' }" @click="switchUserType('supplier')">供应商</div>
      </div>

      <!-- 注册表单 -->
      <form class="register-form" @submit.prevent="handleRegister">
        <!-- 企业名称 -->
        <div class="form-item">
          <span class="form-label">企业名称<i class="required-star">*</i></span>
          <input v-model="form.companyName" placeholder="请输入企业名称" class="form-input" />
        </div>

        <!-- 联系人 -->
        <div class="form-item">
          <span class="form-label">联系人<i class="required-star">*</i></span>
          <input v-model="form.contactName" placeholder="请输入联系人姓名" class="form-input" />
        </div>

        <!-- 联系方式 -->
        <div class="form-item">
          <span class="form-label">联系方式<i class="required-star">*</i></span>
          <input v-model="form.contactPhone" placeholder="请输入联系方式" maxlength="11" class="form-input" @input="form.contactPhone = form.contactPhone.replace(/[^\d]/g, '')" />
        </div>

        <!-- 验证码 -->
        <div class="form-item">
          <span class="form-label">验证码<i class="required-star">*</i></span>
          <div class="verify-code-row">
            <input v-model="form.verifyCode" placeholder="请输入验证码" class="form-input verify-input" />
            <button type="button" class="verify-btn" :disabled="smsCountdown > 0" @click="sendVerifyCode">
              {{ smsCountdown > 0 ? `${smsCountdown}s` : "获取验证码" }}
            </button>
          </div>
        </div>

        <!-- 职务 -->
        <div class="form-item">
          <span class="form-label">职务<i class="required-star">*</i></span>
          <input v-model="form.position" placeholder="请输入您的职务" class="form-input" />
        </div>

        <!-- 微信号 -->
        <div class="form-item">
          <span class="form-label">微信号</span>
          <input v-model="form.wechat" placeholder="请输入微信号" class="form-input" />
        </div>

        <!-- E-mail -->
        <div class="form-item">
          <span class="form-label">E-mail</span>
          <input v-model="form.email" placeholder="请输入E-mail" class="form-input" />
        </div>

        <!-- 地址 -->
        <div class="form-item">
          <span class="form-label">地址<i class="required-star">*</i></span>
          <input v-model="form.address" placeholder="请输入企业地址" class="form-input" />
        </div>

        <!-- 密码 -->
        <div class="form-item">
          <span class="form-label">密码<i class="required-star">*</i></span>
          <div class="password-input-wrapper">
            <input v-model="form.password" :type="showPassword ? 'text' : 'password'" placeholder="请设置登录密码" class="form-input" />
            <img class="password-toggle" :src="showPassword ? showImg : showNoImg" @click="showPassword = !showPassword" />
          </div>
        </div>

        <!-- 确认密码 -->
        <div class="form-item">
          <span class="form-label">确认密码<i class="required-star">*</i></span>
          <div class="password-input-wrapper">
            <input v-model="form.confirmPassword" :type="showConfirmPassword ? 'text' : 'password'" placeholder="请再次输入密码" class="form-input" />
            <img class="password-toggle" :src="showConfirmPassword ? showImg : showNoImg" @click="showConfirmPassword = !showConfirmPassword" />
          </div>
        </div>

        <!-- 注册目的 -->
        <div class="form-item">
          <span class="form-label">注册目的?</span>
          <label class="purpose-checkbox" @click="form.purpose = !form.purpose">
            <img :src="form.purpose ? selected2Img : noSelected2Img" class="purpose-icon" />
            <span>{{ userType === "buyer" ? "求购产品" : "寻找客户" }}</span>
          </label>
        </div>

        <!-- 头像 -->
        <div class="form-item">
          <span class="form-label">头像</span>
          <ImageUpload v-model="form.headPortrait" :multiple="false" size="80px" dir="avatar" />
        </div>

        <!-- 公司营业执照 -->
        <div class="form-item">
          <span class="form-label">公司营业执照<i class="required-star">*</i></span>
          <ImageUpload v-model="form.businessLicense" :multiple="true" :limit="5" size="120px" dir="license" />
        </div>

        <!-- 提交按钮 -->
        <div style="text-align: center; margin-top: 20px">
          <button type="submit" class="submit-btn" :disabled="loading">
            {{ loading ? "注册中..." : "立即注册" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { register, getVerCode } from "@/api";
import ImageUpload from "@/components/ImageUpload.vue";

export default {
  name: "Register",
  components: { ImageUpload },
  data() {
    return {
      userType: "buyer", // buyer: 采购方, supplier: 供应商
      loading: false,
      selected2Img: require("@/assets/image/selected2.png"),
      noSelected2Img: require("@/assets/image/no-selected2.png"),
      showImg: require("@/assets/image/show.png"),
      showNoImg: require("@/assets/image/show-no.png"),
      form: {
        companyName: "",
        contactName: "",
        contactPhone: "",
        verifyCode: "",
        position: "",
        wechat: "",
        email: "",
        address: "",
        password: "",
        confirmPassword: "",
        purpose: true,
        headPortrait: "",
        businessLicense: [],
      },
      smsCountdown: 0,
      smsTimer: null,
      showPassword: false,
      showConfirmPassword: false,
    };
  },
  beforeDestroy() {
    if (this.smsTimer) {
      clearInterval(this.smsTimer);
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    switchUserType(type) {
      this.userType = type;
    },
    sendVerifyCode() {
      if (!this.form.contactPhone) {
        this.$message.warning("请输入联系方式");
        return;
      }
      this.smsCountdown = 60;
      getVerCode({ phoneNumber: this.form.contactPhone })
        .then(() => {
          this.$message.success("验证码已发送");
          this.smsTimer = setInterval(() => {
            this.smsCountdown--;
            if (this.smsCountdown <= 0) {
              clearInterval(this.smsTimer);
            }
          }, 1000);
        })
        .catch((err) => {
          this.$message.error(err.message || "验证码发送失败，请稍后重试");
        });
    },
    handleRegister() {
      // 手动校验
      if (!this.form.companyName.trim()) {
        this.$message.warning("请输入企业名称");
        return;
      }
      if (!this.form.contactName.trim()) {
        this.$message.warning("请输入联系人姓名");
        return;
      }
      if (!this.form.contactPhone.trim()) {
        this.$message.warning("请输入联系方式");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.form.contactPhone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      if (!this.form.verifyCode.trim()) {
        this.$message.warning("请输入验证码");
        return;
      }
      if (!this.form.position.trim()) {
        this.$message.warning("请输入您的职务");
        return;
      }
      if (!this.form.address.trim()) {
        this.$message.warning("请输入企业地址");
        return;
      }
      if (!this.form.password) {
        this.$message.warning("请设置登录密码");
        return;
      }
      if (this.form.password.length < 6) {
        this.$message.warning("密码长度不能少于6位");
        return;
      }
      if (!this.form.confirmPassword) {
        this.$message.warning("请再次输入密码");
        return;
      }
      if (this.form.password !== this.form.confirmPassword) {
        this.$message.warning("两次输入密码不一致");
        return;
      }
      if (this.form.businessLicense && this.form.businessLicense.length == 0) {
        this.$message.warning("请上传公司营业执照");
        return;
      }

      console.log(this.form.businessLicense);

      this.loading = true;

      const requestData = {
        headPortrait: this.form.headPortrait,
        enterpriseName: this.form.companyName,
        relationName: this.form.contactName,
        relationPhone: this.form.contactPhone,
        postName: this.form.position,
        role: this.userType === "buyer" ? "purchase" : "supplier",
        wxNumber: this.form.wechat,
        mail: this.form.email,
        address: this.form.address,
        password: this.form.password,
        businessLicense: Array.isArray(this.form.businessLicense) ? this.form.businessLicense.join(",") : this.form.businessLicense,
        verCode: this.form.verifyCode,
      };

      register(requestData)
        .then(() => {
          this.loading = false;
          this.$message.success("注册成功");
          this.$router.push("/login");
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.message || "注册失败，请稍后重试");
        });
    },
  },
};
</script>

<style scoped>
.register-page {
  min-height: 100vh;
  background: #e8f0fe;
  padding-bottom: 40px;
}

.register-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 360px 0 360px;
}

.header-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
}

.header-back {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #666;
  font-size: 14px;
}

.back-icon {
  width: 24px;
  height: 24px;
}

.back-text {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  margin-left: 6px;
}

.register-card {
  width: 690px;
  margin: 30px auto 0;
  background: #fff;
  border-radius: 30px;
  padding: 36px 50px 40px;
  box-sizing: border-box;
}

.type-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
  gap: 20px;
}

.type-tab {
  width: 200px;
  height: 44px;
  line-height: 42px;
  text-align: center;
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  cursor: pointer;
  font-size: 18px;
  color: #333;
  transition: all 0.3s;
}

.type-tab.active {
  background: #1869ff;
  color: #fff;
  border-color: #1869ff;
}

.register-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.form-item {
  display: flex;
  align-items: flex-start;
}

.form-label {
  width: 130px;
  flex-shrink: 0;
  font-size: 18px;
  color: #333;
  font-weight: 500;
  line-height: 54px;
  text-align: right;
  padding-right: 12px;
}

.required-star {
  color: #ff4d4f;
  font-style: normal;
}

.form-input {
  flex: 1;
  height: 54px;
  line-height: 54px;
  border: 1px solid #dcdfe6;
  border-radius: 10px;
  font-size: 18px;
  color: #333;
  padding: 0 15px;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.3s;
  background: #fff;
}

.form-input:focus {
  border-color: #1869ff;
}

.form-input::placeholder {
  color: #c0c4cc;
}

.password-input-wrapper {
  flex: 1;
  position: relative;
}

.password-input-wrapper .form-input {
  width: 100%;
  padding-right: 60px;
}

.password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 26px;
  height: 26px;
  cursor: pointer;
  user-select: none;
}

.password-toggle:hover {
  opacity: 0.7;
}

.verify-code-row {
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
}

.verify-input {
  flex: 1;
}

.verify-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #1869ff;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
}

.verify-btn:disabled {
  color: #999;
  cursor: not-allowed;
}

.purpose-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 54px;
  font-size: 18px;
  color: #333;
  cursor: pointer;
}

.purpose-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.submit-btn {
  width: 100%;
  height: 56px;
  background: #1869ff;
  border: none;
  border-radius: 14px;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
  transition: opacity 0.2s;
}

.submit-btn:hover {
  opacity: 0.9;
}

.submit-btn:active {
  opacity: 0.85;
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
